const lenis = new Lenis({
    duration: 1.2,   
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
        
    smoothWheel: true, 
    smoothTouch: false 
})

    function raf(time) {
        lenis.raf(time)
        requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)

// ------------- hero section animation -----------------
// if(location.pathname=="" || location.pathname=="/" ){
// lenis.stop();

// setTimeout(()=>{
//     lenis.start()
// },5800)
// }

// spline-wrapper



// document.addEventListener("DOMContentLoaded",()=>{
// if(location.pathname=="" || location.pathname=="/" ){

//   const splineViewer = document.querySelector('.hero_three-d');
//   setTimeout(() => {
//   splineViewer.setAttribute('url', 'https://prod.spline.design/0x2r4q-okmaaBAOn/scene.splinecode');
    
//   }, 4800);
// }
// })

// spline-wrapper

// if (window.innerWidth > 950) {

//   gsap.fromTo(".hero-img-div img", {
//       scale: 0.1,
//       borderRadius : "50vw",
//   },
//   {
//       borderRadius : "1vw",
//       scale: 1,
//       ease: "power3.out",
//       duration: 5,
//       delay : .5,
//   })

//   gsap.fromTo(".hero-shop-btn", {
//       display : "none",
//       y: 10,
//       scale: 0.75,
//   },
//   {
//       y  : 0,
//       display: "flex",
//       scale: 1,
//       ease: "power3.out",
//       duration: 2.5,
//       delay : 3.5,
//   })
//   gsap.fromTo(".hero-heading", {
//       display : "none",
//       y: 10,
//       scale: 0.25,
//   },
//   {
//       y  : 0,
//       display: "block",
//       scale: 1,
//       ease: "power3.out",
//       duration: 2.5,
//       delay : 2.75,
//   })
// }
// if (window.innerWidth < 950) {

//   gsap.fromTo(".hero-img-div img", {
//       scale: 0.25,
//       borderRadius : "15vw",
//   },
//   {
//       borderRadius : "5vw",
//       scale: 1,
//       ease: "power3.out",
//       duration: 5,
//       delay : 0.5,
//   })

//    gsap.fromTo(".hero-shop-btn", {
//       display : "none",
//       scale: 0.75,
//   },
//   {
//       display: "flex",
//       scale: 1,
//       ease: "power3.out",
//       duration: 2.5,
//       delay : 3.5,
//   })
//   gsap.fromTo(".hero-heading", {
//       display : "none",
//       y: 10,
//       scale: 0.25,
//   },
//   {
//       y  : 0,
//       display: "block",
//       scale: 1,
//       ease: "power3.out",
//       duration: 2.5,
//       delay : 2.75,
//   })
  
// }


// ------------ img Animation base on scrolling ------------

// gsap.utils.toArray(".big-img").forEach((bigImg) => {
//       gsap.fromTo(
//         bigImg,
//         { scale: 0.5, opacity: 0.7, y: 30 ,
//         },
//         {
//           scale: 1,
//           opacity: 1,
//           y: 0,
//           ease: "power1.out",
//           scrollTrigger: {
//             trigger: bigImg,
//             start: "top 90%",   
//             end: "top 40%",  
//             // markers : true,  
//             scrub: 2,       
//           },
//         }
//       );
//     });

// ----------- text aniamtion -------------

// ------------------ para Animation ------------

// gsap.utils.toArray(".rotate-flip").forEach((el) => {
//   let split = new SplitText(el, {          
//     type: "words,chars",           
//    });

//   gsap.from(split.chars, {
//     rotationX: 90,
//     opacity: 0,
//     stagger: 0.05,
//     ease: "back.out(1.7)",
//     scrollTrigger: {
//       trigger: el,
//       start: "top 90%",
//       end: "top 70%",
//       scrub: 2,
//       // markers: true
//     },
//   });
// });

// ------------ title blur aniamtion ---------------

gsap.utils.toArray(".scale-animation").forEach((el) => {
    gsap.from(el, {              
      opacity: 0,         
      scale: 0.5, 
      filter: "blur(10px)", 
      duration: 1.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",  
        end: "top 40%",
        scrub: 2,      
        markers: false
      }
    });
  });

// ----------------------------- title-aniamtion ---------------

// gsap.utils.toArray(".title-aniamtion").forEach(title => {
//   let split = new SplitText(title, { type: "chars" });
//   gsap.from(split.chars, {
//     rotationY: 90,
//     y: 20,
//     opacity: 0,
//     stagger: 0.05,
//     ease: "power3.out",
//     scrollTrigger: {
//       trigger: title,
//       start: "top 90%",
//       end: "top 50%",
//       scrub: 2
//     }
//   });
// });

// --------------- bottom-img-aniamton -----------------

gsap.utils.toArray(".bottom-img-aniamton").forEach((img) => {
    gsap.from(img, {
      rotateY: 90, scale: 0.7, opacity: 0,                 
      duration: 1.5,
      ease: "power3.out",
      scrollTrigger: {
        trigger: img,
        start: "top 85%",   
        end: "top 40%",     
        scrub: 2,       
        markers: false     
      }
    });
  });


// ------------------ Circle + Bubble Animation ----------------
// gsap.registerPlugin(ScrollTrigger);

// const circle = document.querySelector("#progress");
// const bubbles = gsap.utils.toArray(".bubble");
// const centerContent = document.querySelector(".center-content");

// let tl = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".circle-section",
//     start: "top top",
//     end: "+=4000",
//     scrub: true,
//     pin: true,
//     // markers: true,
//   }
// });

// tl.to(circle, {
//   strokeDashoffset: 0,
//   ease: "none",
// }, 0);

// bubbles.forEach((bubble, i) => {
//   let fromVars = { opacity: 0, scale: 0.5 };

//   tl.fromTo(
//     bubble,
//     fromVars,
//     { opacity: 1, scale: 1, ease: "back.out(1.7)" },
//     i * 0.5 + 0.5 
//   );
// });

// tl.fromTo(centerContent,
//   { opacity: 0, scale: 0.5, y: 50 },
//   { opacity: 1, scale: 1, y: 0, ease: "back.out(1.7)" },
// );

// ------------- Buy Button in liquid-circle --------------

// if (window.innerWidth < 950) {

//  gsap.to(".hero-img-div img", {                       
//       borderRadius : "0 0 50vw 50vw",
//       duration: 1.2,
//       ease: "power3.out",
//       scrollTrigger: {
//         trigger: ".hero-img-div img",
//         start: "top 0%",  
//         end: "top -40%",
//         scrub: 1,      
//         markers: false,
//       }
//     });
//   }
// document.addEventListener("DOMContentLoaded",()=>{
//   document.querySelector(".product-form__submit").addEventListener("click",()=>{
//     location.href = "/checkout"
//   })
// })